module.exports = __webpack_public_path__ + "img/shiyou-2.f35038a4.jpg";